import { Dialog } from "primereact/dialog"
import Documents from "../pages/Documents"
import Housing from "../pages/Housing/Index"

export default function AdditionalServicesOverlays({ toggles, setToggles }) {
  return (
    <>
      {/* Documents renders when its toggle is enabled by menu actions. */}
      {toggles.documentsOpen && (
        <Documents toggles={toggles} setToggles={setToggles} />
      )}

      {/* Housing dialog visibility is managed through the shared toggles object. */}
      {toggles.housingOpen && (
        <Dialog
          header={"Housing"}
          visible={toggles.housingOpen}
          onHide={() => {
            setToggles((prev) => ({ ...prev, housingOpen: false }))
          }}
          style={{
            width: "min(1340px, 95vw)",
            maxWidth: "95vw",
            height: "min(1000px, 90vh)",
          }}
        >
          <Housing />
        </Dialog>
      )}
    </>
  )
}
